import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import MenuBar from './components/MenuBar';
import Explorer from './components/Explorer';
import Breadcrumb from './components/Breadcrumb';
import FloatingBackground from './components/FloatingBackground';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Education from './components/Education';
import Contact from './components/Contact';

function App() {
  const [activeSection, setActiveSection] = useState('hero');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const skillsRef = useRef(null);
  const experienceRef = useRef(null);
  const projectsRef = useRef(null);
  const educationRef = useRef(null);
  const contactRef = useRef(null);

  const sectionRefs = {
    hero: heroRef,
    about: aboutRef,
    skills: skillsRef,
    experience: experienceRef,
    projects: projectsRef,
    education: educationRef,
    contact: contactRef
  };

  const handleNavigate = (sectionId) => {
    setActiveSection(sectionId);
    sectionRefs[sectionId]?.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('data-section');
            setActiveSection(id);
          }
        });
      },
      { threshold: 0.5 }
    );

    Object.values(sectionRefs).forEach(ref => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => observer.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App light">
      <FloatingBackground />
      <div className="app-container">
        <MenuBar 
          onNavigate={handleNavigate} 
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
        <div className="app-body">
          <Explorer 
            onNavigate={(section) => {
              handleNavigate(section);
              setIsMobileMenuOpen(false);
            }} 
            activeSection={activeSection} 
            isMobileMenuOpen={isMobileMenuOpen}
          />
          <div className="main-content">
            <Breadcrumb activePage={activeSection} />
            <div className="content-area">
              <div ref={heroRef} data-section="hero"><Hero /></div>
              <div ref={aboutRef} data-section="about"><About /></div>
              <div ref={skillsRef} data-section="skills"><Skills /></div>
              <div ref={experienceRef} data-section="experience"><Experience /></div>
              <div ref={projectsRef} data-section="projects"><Projects /></div>
              <div ref={educationRef} data-section="education"><Education /></div>
              <div ref={contactRef} data-section="contact"><Contact /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
